<section class="dnb-usage" data-testid="dnb-usage-card">
  <div class="dnb-usage__header">
    <div>
      <h4 class="m-0 f-s-16 f-w-600">D&B usage check</h4>
      <p class="m-0 f-s-14 text-gray-100">
        Compare D&B Metered Usage with companies observed by Shine. Opening this card does not enroll a watchlist.
      </p>
    </div>
    <button mat-button type="button" (click)="refresh()" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon>
      Check now
    </button>
  </div>

  @if (isLoading) {
    <div class="dnb-usage__loading" data-testid="dnb-usage-loading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Checking D&B usage…</span>
    </div>
  } @else if (error) {
    <div class="error-message" data-testid="dnb-usage-error"><p>{{ error }}</p></div>
  } @else if (status && !status.enabled) {
    <div class="dnb-usage__note" data-testid="dnb-usage-disabled">
      D&B is not enabled for this client. No provider or ledger check was performed.
    </div>
  } @else if (status) {
    <div class="dnb-usage__summary">
      <mat-card class="dnb-usage__metric">
        <span>D&B reported RUM</span>
        <strong data-testid="dnb-reported-rum">{{ status.provider.reportedRum ?? 'Unavailable' }}</strong>
        <small>Contract limit: {{ status.provider.limit ?? 'Unavailable' }}</small>
      </mat-card>
      <mat-card class="dnb-usage__metric">
        <span>Observed by Shine</span>
        <strong data-testid="shine-observed-companies">{{ status.shine.observedCompanies ?? 'Unavailable' }}</strong>
        <small>Distinct companies with completed hierarchy reads</small>
      </mat-card>
      <mat-card class="dnb-usage__metric">
        <span>Paid reads today</span>
        <strong>{{ status.shine.paidReadsToday ?? 'Unavailable' }}</strong>
        <small>Daily cap: {{ status.shine.dailyLimit ?? 'Unavailable' }}</small>
      </mat-card>
      <mat-card class="dnb-usage__metric">
        <span>Watchlist</span>
        <strong data-testid="dnb-watchlist-status">Off</strong>
        <small>No automatic enrollment</small>
      </mat-card>
    </div>

    <div class="dnb-usage__comparison" [class]="'dnb-usage__comparison dnb-usage__comparison--' + status.comparison">
      <mat-icon>{{ status.comparison === 'aligned' ? 'check_circle' : status.comparison === 'different' ? 'warning' : 'help' }}</mat-icon>
      <div>
        <strong data-testid="dnb-usage-comparison">{{ comparisonLabel(status.comparison) }}</strong>
        <p class="m-0 f-s-13 text-gray-100">
          D&B meter updated
          {{ status.provider.lastMeterUpdatedAt ? (status.provider.lastMeterUpdatedAt | date:'medium') : 'at an unavailable time' }}.
        </p>
      </div>
    </div>

    @if (status.provider.meters.length) {
      <div class="dnb-usage__meters" data-testid="dnb-usage-meters">
        @for (meter of status.provider.meters; track meter.productName + meter.region) {
          <div>
            <span>{{ meter.productName }} · {{ meter.region }}</span>
            <strong>{{ meter.currentUsage ?? 'Unavailable' }} / {{ meter.limit }}</strong>
          </div>
        }
      </div>
    }
  }
</section>
